module.exports = __webpack_public_path__ + "3882d23c1dd29732432b5f13f7ddd940.pdf";